import React, { useEffect, useState } from 'react';
import Menu from '../../components/Menu';
import api from '../../services/api';


function Contato(props){    
    const [trava, setTrava] = useState(true);
    const [assunto, setAssunto] = useState('');
    const [msg, setMsg] = useState('Sua mensagem sera lida e respondida em breve.');
    const [mensagem, setMensagem] = useState('');
    const Voltar = (e) => {
        e.preventDefault(0);
        window.location = './Painel';
        return;
    }

    const Enviar = async(e) => {
        e.preventDefault(0);
        var res = await api.post('/contato', {assunto: assunto, msg: mensagem});
        console.log(res.data);
       
        if(res.data.msg === 'token invalido.'){
           
            window.location = '../Sair';
            setMsg('Token invalido, refaça seu login.');
        }else if(res.data.msg){
            setMsg(res.data.msg);
            setAssunto('');
            setMensagem('');
        }
    };

    useEffect(() => {

        async function getDados(){
            let dados = await api.get('perfil');
            console.log(dados.data);
            if(dados.data.msg === 'token invalido.'){
                window.location = '../Sair';
                setTrava(true);
            }else{    
                if(dados.data === '"null"'){
                    setTrava(true);
        
                }else{
                    setTrava(false);
                   // setDados(dados.data);
                }
            }
        }
        getDados();
    }, []);
    return (<div class="main-content" style={{marginLeft: '0'}}>
        <Menu />
    <div id="page-wrapper">
        <div class="container">
            <div class="row">
                <div class="col-md-4 col-md-offset-4" style={{marginTop: '100px'}}>
                    <img src={'../public/assets/logoupbusca.png'} alt="Up Busca" class="center-block img-responsive" id="logo" style={{marginTop: '-10%'}}/>
                </div>
            </div>
        </div>
    <div>

    {trava == false ? <div class="row">
          <div class="col-md-10 col-md-offset-1">
            <ul class="nav nav-tabs" role="tablist" style={{marginTop: '0px'}}>
                <li role="presentation" class="active">
                    <a href="#home" aria-controls="home" role="tab" data-toggle="tab" class="tab-result">Suporte</a>
                </li>
            </ul>

            <div class="tab-content">
                <div role="tabpanel" class="tab-pane active" id="home">
                    <div class="table-responsive" style={{marginTop: '12px'}}>
                    <div class="row">

                        <div class="form-group col-md-12">
                            <span>Assunto:</span>
                            <select class="form-control" name="assunto" id="assunto" onChange={(e)=>setAssunto(e.target.value)}>
                                <option value="1">Financeiro</option>
                                <option value="2">Suporte - Duvidas</option>
                                <option value="3">Sugestoes - Reclamações</option>
                                <option value="4">Outros</option>
                                <option value="5" selected>Selecione uma opção</option>
                            </select>

                        </div>

                        <div class="form-group col-md-12">
                            <span>Digite sua mensagem:</span>
                            <textarea class="form-control" value={mensagem} onChange={(e)=>setMensagem(e.target.value)} rows="4" name="mensagem" id="mensagem" cols="10"></textarea>
                            <center><br/>{msg.length > 0 && (<spam>{msg}</spam>)}</center>
                        </div>
        	        </div>
                    <center>
                        <button class="btn btn-primary" onClick={Enviar} type="button" name="nova_consulta" id="nova_consulta">Enviar</button>
                    </center>
                    </div>
                </div>
                <br/>
            </div>
        </div>
    </div> : (``)}

  
</div>
</div></div>);
}

export default Contato;
